import { createFeatureSelector } from '@ngrx/store';
import { EditFlowState, FlowConfigurationState, SearchFlowsState, SideNavState } from '../models/flows.model';
import { EditFlowReducer } from './edit-flow.reducer';
import { FlowConfigurationReducer } from './flow-configuration.reducer';
import { SearchFlowsReducer } from './search-flows.reducer';
import { SideNavReducer } from './side-nav.reducer';

export const featureFlowsName = 'Flows';

export interface DragonflyState {
  flowsSearch: SearchFlowsState;
  flowsConfiguration: FlowConfigurationState;
  editFlow: EditFlowState;
  sideNav: SideNavState;
}

export const moduleFlowsReducers = {
  flowsSearch: SearchFlowsReducer,
  flowsConfiguration: FlowConfigurationReducer,
  editFlow: EditFlowReducer,
  sideNav: SideNavReducer,
};

export const getDragonflyState = createFeatureSelector<DragonflyState>(featureFlowsName);
